<script setup lang="ts">
import MainLayout from '@/components/layout/MainLayout.vue'
import { Button } from '@/components/ui/button'
import { useForm11 } from '@/composables/useForm11'
import { useTaxbackCredits } from '@/composables/useTaxbackCredits'
import { formatMoney } from '@/lib/utils/money'
import { useRouter } from 'vue-router'

const router = useRouter()
const { taxback } = useForm11()
const { totalTaxbackCredits } = useTaxbackCredits()

const options = [
  { icon: '/icons/bank.png', label: 'Move to your bank account' },
  { icon: '/icons/pension.png', label: 'Reinvest to your pension' },
  { icon: '/icons/financialProtection.png', label: 'Financial protection' },
  { icon: '/icons/smartInvest.png', label: 'Smart Invest savings' },
  { icon: '/icons/buildEmergencyFund.png', label: 'Build emergency fund' },
  { icon: '/icons/payIrishLife.png', label: 'Pay Irish Life Health Premium' },
  { icon: '/icons/car-insurance.png', label: 'Car insurance' },
  { icon: '/icons/home-insurance.png', label: 'Home insurance' },
]
</script>

<template>
  <MainLayout>
    <div class="space-y-6 mb-12">
      <h1 class="text-2xl font-bold mt-8 text-center">
        What to do with my<br />
        tax return?
      </h1>

      <!-- Tax Refund Amount Display -->
      <div
        class="bg-white rounded-2xl shadow-md p-6 flex items-center justify-center"
      >
        <span class="text-[28px] font-semibold text-maximo-green">{{
          formatMoney(taxback + totalTaxbackCredits)
        }}</span>
      </div>

      <div class="grid grid-cols-2 gap-4">
        <div
          v-for="option in options"
          :key="option.label"
          class="cursor-pointer bg-white hover:bg-slate-50 transition-colors rounded-2xl shadow-md"
        >
          <div class="flex flex-col items-center justify-center p-6 space-y-4">
            <img
              :src="option.icon"
              :alt="option.label"
              class="w-12 h-12 object-contain"
            />
            <span class="text-center px-2">{{ option.label }}</span>
          </div>
        </div>
      </div>
      <Button
        size="lg"
        class="w-full"
        @click="router.push('/tax-refund-questions')"
        >Boost My Tax Refund</Button
      >
    </div>
  </MainLayout>
</template>
